import React from 'react'
import PropTypes from 'prop-types'
import withProps from 'recompose/withProps'
import styled, { css } from 'react-emotion'
import SmartLink from 'components/SmartLink'
import { regularFontFamily } from 'utils/style-helpers'

export const ButtonCss = css`
  ${regularFontFamily()}
  background: #4caf50;
  border: none;
  border-radius: 9999px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  height: 64px;
  letter-spacing: 2.4px;
  line-height: 64px;
  padding: 0;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
`

const LinkButton = styled(SmartLink)`
  ${ButtonCss};
`

export default LinkButton

export const LargeLinkButton = styled(LinkButton)`
  font-size: 18px;
  letter-spacing: 3.6px;
`



// WEBPACK FOOTER //
// ./src/components/LinkButton/index.js